import { autorun } from 'mobx';

import { debounce } from 'lodash';
import { useCallback, useEffect } from 'react';
import WaveformData from 'waveform-data';
import { useVideoCreatorStore } from '@src/stores-v2/VideoCreatorStoreContext';

type Props = {
  url: string;
  customTimelineScale?: number;
  isInMusicProducer: boolean;
};

export const useWaveformResample = (props: Props) => {
  const videoCreator = useVideoCreatorStore();
  const { customTimelineScale, isInMusicProducer, url } = props;
  const isOriginalVideo = url === videoCreator.originalVideoAudioUrl;
  const waveform: WaveformData | undefined | null = isOriginalVideo
    ? videoCreator.originalWaveForm
    : //@ts-ignore
      videoCreator.audioTracksData[url]?.waveform;

  useEffect(() => {
    videoCreator.resampledOriginalWaveForm = {
      status: 'loading',
      data: null,
    };
    debounceGenerateWaveform(customTimelineScale || videoCreator.timelineScale);
  }, [waveform, videoCreator.timelineScale, customTimelineScale]);

  const generateWaveform = useCallback(
    (timelineScale: number) => {
      if (!waveform) {
        console.log('No waveform', url);
        return;
      }

      const currentResampledWaveform: WaveformData | undefined | null =
        isOriginalVideo
          ? videoCreator.resampledOriginalWaveForm?.data
          : //@ts-ignore
            videoCreator.audioTracksData[url]?.resampledWaveform;

      const maxTimelineScale = isInMusicProducer
        ? 180
        : videoCreator.maxTimelineScale;

      const currentMaxTimelineScale = Math.min(
        maxTimelineScale,
        Math.floor(waveform.sample_rate / waveform.scale),
      );
      let scale = Math.max(
        Math.ceil(waveform.sample_rate / timelineScale),
        Math.ceil(waveform.sample_rate / currentMaxTimelineScale),
      );

      if (currentResampledWaveform?.scale !== scale) {
        console.log('resampling waveform for', url, scale, timelineScale);
        const resampledWaveform = waveform.resample({ scale });
        if (isOriginalVideo) {
          videoCreator.resampledOriginalWaveForm = {
            status: 'ready',
            data: resampledWaveform,
          };
        } else {
          //@ts-ignore
          videoCreator.audioTracksData[url].resampledWaveform =
            resampledWaveform;
        }
      }
    },
    [waveform],
  );

  const debounceGenerateWaveform = useCallback(
    debounce((scale) => generateWaveform(scale), 2050),
    [waveform],
  );
};
